import axios from 'axios'

const client = axios.create({
  baseURL: '/api',
  timeout: 10000
})

client.interceptors.request.use(config => {
  const token = window.localStorage.getItem('tailwater_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  config.params = { ...config.params, workspace: window.localStorage.getItem('tailwater_workspace') || 'ALL' }
  return config
})

client.interceptors.response.use(response => {
  const body = response.data
  if (body && body.success === false) return Promise.reject(new Error(body.message || '请求失败'))
  return body && Object.prototype.hasOwnProperty.call(body, 'data') ? body.data : body
}, error => {
  if (error.response && error.response.status === 401) {
    window.localStorage.removeItem('tailwater_token')
    if (window.location.pathname !== '/login') window.location.replace('/login')
  }
  const message = error.response && error.response.data && error.response.data.message
  return Promise.reject(new Error(message || '无法连接后端服务'))
})

export const api = {
  logout: () => client.post('/auth/logout'),
  changePassword: payload => client.post('/auth/change-password', payload),
  dashboard: () => client.get('/dashboard'),
  units: () => client.get('/units'),
  createUnit: payload => client.post('/units', payload),
  updateUnit: (id, payload) => client.put(`/units/${id}`, payload),
  detections: () => client.get('/detections'),
  createDetection: payload => client.post('/detections', payload),
  updateDetection: (id, payload) => client.put(`/detections/${id}`, payload),
  rules: () => client.get('/rules'),
  createRule: payload => client.post('/rules', payload),
  updateRule: (id, payload) => client.put(`/rules/${id}`, payload),
  rectifications: () => client.get('/rectifications'),
  createRectification: payload => client.post('/rectifications', payload),
  updateRectification: (id, payload) => client.put(`/rectifications/${id}`, payload),
  archives: () => client.get('/archives'),
  createArchive: payload => client.post('/archives', payload),
  audits: () => client.get('/audits'),
  users: () => client.get('/users')
}
